

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

export default class SwiperManager {
  constructor(selector, options = {}) {
    this.selector = selector;
    this.onlyMobile = options.onlyMobile || false;
    this.breakpoint = options.breakpoint || 768;

    const baseModules = [Navigation, Pagination];

    if (options.swiper && options.swiper.autoplay) {
      baseModules.push(Autoplay);
    }

    this.swiperOptions = Object.assign(
      {
        modules: baseModules,
        slidesPerView: 1,
        spaceBetween: 10,
        loop: false,
        pagination: { el: '.swiper-pagination', clickable: true },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      options.swiper || {}
    );

    this.swipers = [];
    this.init();
  }

  init() {
    this.elements = document.querySelectorAll(this.selector);
    if (!this.elements.length) return;

    this.createOrDestroy();

    window.addEventListener('resize', this.createOrDestroy.bind(this));
  }

  createOrDestroy() {
    const isMobile = window.innerWidth < this.breakpoint;

    this.elements.forEach((el) => {
      const existing = el.swiperInstance;

      if (this.onlyMobile && isMobile && !existing) {
        this.createSwiper(el);
      } else if (this.onlyMobile && !isMobile && existing) {
        this.destroySwiper(el);
      } else if (!this.onlyMobile && !existing) {
        this.createSwiper(el);
      }
    });
  }

  createSwiper(el) {
    const swiperEl = el.querySelector('.swiper') || el;
    if (!swiperEl) return;

    const swiper = new Swiper(swiperEl, this.swiperOptions);
    el.swiperInstance = swiper;
    this.swipers.push(swiper);
  }

  destroySwiper(el) {
    if (!el.swiperInstance) return;
    el.swiperInstance.destroy(true, true);
    el.swiperInstance = null;
  }
}
